import { DateTime } from "luxon";
import { BaseFirestoreData, PathParam } from "../util/base-firestore";
import { type UploadFile } from "../model/file";
import { type BasePaperDefaultSettings, getEmptyBasePaperDefaultSettings } from "./paper/base-paper";

// オーガナイゼーション外から参照できないやつ
export class Organization extends BaseFirestoreData {
  organizationId: string;
  name: string;

  plan: "free" | "readonly" | "trial" | "paid";
  trialEndAt: DateTime | null; // トライアル期間の終了日時
  registerStep: "1" | "2" | "100"; // 初期設定、終わったページを保存する 100で完了

  invoiceRegistrationNumber: string; // 適格請求書発行事業者登録番号

  // 自分でアップしたファイルの数と容量
  uploadFileCount?: number;
  uploadFileSizeSum?: number;

  // ロゴと角印/表示設定
  // invoiceDefaultSettings?: InvoiceDefaultSettings;
  logo?: UploadFile;
  kakuin?: UploadFile;
  defaultSettings: {
    invoice: BasePaperDefaultSettings<"invoice">;
    quotation: BasePaperDefaultSettings<"quotation">;
    deliveryNote: BasePaperDefaultSettings<"deliveryNote">;
  };
}

export const getEmptyOrganization = (): Organization => {
  return {
    organizationId: "",

    plan: "free",
    trialEndAt: null,

    name: "",
    invoiceRegistrationNumber: "",

    registerStep: "1",

    defaultSettings: {
      invoice: getEmptyBasePaperDefaultSettings("invoice"),
      quotation: getEmptyBasePaperDefaultSettings("quotation"),
      deliveryNote: getEmptyBasePaperDefaultSettings("deliveryNote"),
    },

    createdAt: DateTime.now(),
    updatedAt: DateTime.now(),
    deletedAt: null,
  };
};

export class OrganizationCollectionPathParam extends PathParam {}
export class OrganizationDocumentPathParam extends PathParam {
  organizationId: string;
}

export const OrganizationPath = [
  {
    path: "organizations/",
    primaryKey: "organizationId",
    param: OrganizationCollectionPathParam,
    class: Organization,
    isCollection: true,
  },
  {
    path: "organizations/{organizationId}",
    primaryKey: "organizationId",
    param: OrganizationDocumentPathParam,
    class: Organization,
  },
] as const;
